import React from 'react';

import GetBoard from '@src/api/GetBoard';
import { generateRank } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { Rank } from '@src/types';

const useBoard = (type: 'all' | 'friends' | 'monthly' = 'all') => {
  const axiosRequestConfig = useAxiosRequestConfig();
  const [rank, setRank] = React.useState<Rank>();

  const makeRequest = React.useCallback(
    async (offset: number, limit: number): Promise<Rank[]> => {
      const response = await GetBoard(type, offset, limit, axiosRequestConfig);
      setRank(generateRank(response.data.rank));
      return response.data.board.map((r) => generateRank(r));
    },
    [axiosRequestConfig, type]
  );

  const list = useFlatList(makeRequest);

  return React.useMemo(() => ({ list, rank }), [list, rank]);
};

export default useBoard;
